export const reConstructionMaterialPeriodPricesConstants = {
	GetPaged: {
		SUCCESS : 'GET_PAGED_PERIOD_MATERIAL_PRICE_SUCCESS',
		REQUEST : 'GET_PAGED_PERIOD_MATERIAL_PRICE_REQUEST',
		FAILURE : 'GET_PAGED_PERIOD_MATERIAL_PRICE_FAILURE'
	},
	Upload: {
		FAILURE : 'UPLOAD_PERIOD_MATERIAL_PRICES_FAILURE',
		REQUEST : 'UPLOAD_PERIOD_MATERIAL_PRICES_REQUEST',
		SUCCESS : 'UPLOAD_PERIOD_MATERIAL_PRICES_SUCCESS'
	},
	GetExampleFile: {
		FAILURE : 'DOWNLOAD_EXAMPLE_FILE_PERIOD_MATERIAL_PRICES_FAILURE',
		REQUEST : 'DOWNLOAD_EXAMPLE_FILE_PERIOD_MATERIAL_PRICES_REQUEST',
		SUCCESS : 'DOWNLOAD_EXAMPLE_FILE_PERIOD_MATERIAL_PRICES_SUCCESS'
	},
	CLEAR: 'CLEAR_PERIOD_MATERIAL_PRICES'
}